import { render } from "./Browse.vue?vue&type=template&id=d3882794&scoped=true"
import script from "./Browse.vue?vue&type=script&lang=js"
export * from "./Browse.vue?vue&type=script&lang=js"

import "./Browse.vue?vue&type=style&index=0&id=d3882794&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc2-20251202/dbesslnc2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3882794"]])

export default __exports__